var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 63 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09171 5.00968C9.54732 4.55407 10.286 4.55407 10.7416 5.00968L18.9083 13.1763C19.3639 13.632 19.3639 14.3706 18.9083 14.8263L10.7416 22.9929C10.286 23.4485 9.54732 23.4485 9.09171 22.9929C8.6361 22.5373 8.6361 21.7986 9.09171 21.343L16.4334 14.0013L9.09171 6.65959C8.6361 6.20398 8.6361 5.46529 9.09171 5.00968Z",
    fill: "#0B0C0D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/icon-left-arrow.62845ce4feded0ffc3e172f0f4bcde82.svg";
export { ForwardRef as ReactComponent };